module.exports = __webpack_public_path__ + "static/media/small-blue-check-icon.c17968d5.svg";